import { UserPermissions } from '~src/interfaces/session.types';
import { StoreI } from '~src/rootReducer';
import { produce } from 'immer';

export interface GuidedTourPayload {
  userId: string;
  role: 'admin' | 'user';
  createdAt: number;
  language: string;
}

export const initializeUserGuiding = async ({ userId, role, createdAt, language }: GuidedTourPayload) => {
  try {
    (window as any).userGuiding?.identify(
      userId, // unique, required
      {
        language, // for multi-language applications
        role,
        created_at: createdAt,
      },
    );
  } catch (err) {
    console.error('Failed to initialize user-guiding', err);
  }
};

let guidedTourPayload: GuidedTourPayload = {
  userId: '',
  createdAt: 0,
  role: 'user',
  language: '',
};

export const selectGuidedTourPayload = (state: StoreI): GuidedTourPayload | undefined => {
  const user = state.user.session.user;
  if (user && state.attributes) {
    const [systemLangAttributeId] =
      Object.entries(state.attributes.byId).find(([, val]) => val.slug.includes('system_language')) || [];
    const language = systemLangAttributeId ? user.setting_attributes[systemLangAttributeId] : null;
    guidedTourPayload = produce(guidedTourPayload, draft => {
      draft.userId = user.uuid;
      draft.createdAt = new Date(user.created_at).getTime();
      draft.role = user.userPermissions.includes(UserPermissions.ManageCompany) ? 'admin' : 'user';
      draft.language = language || 'en_US';
    });

    return guidedTourPayload;
  }

  return undefined;
};
